import { BaseBus } from './BaseBus';
import { CommonFunctions } from '../static/common-functions';
import { TimeDetailBus } from './TimeDetailBus';
import { CommonValues } from '../static/CommonValues';
import { setValue } from '@datorama/akita';
import { NoTimeForPersonDetailBus } from './NoTimeForPersonDetailBus';

export class TimeForPersonBus extends BaseBus
{
    CID() : any {
        return this.personId;
    }
    setEmptyGuidToNull = false;
    constructor(data: TimeForPersonBus = null) {
        super(data);

        for (let i = 0; i < 5; i++) {
            this.dateHasTime.push(false);
        }
        this.hasDispatchTime = false;
        if (data !== undefined && data !== null) {
            let arr2 = [];
            if (CommonFunctions.hasArrayValue(data.noTimeForPersonDetails)) {
                for (let i = 0; i < data.noTimeForPersonDetails.length; i++) {
                    let newObj: NoTimeForPersonDetailBus = new NoTimeForPersonDetailBus(data.noTimeForPersonDetails[i]);
                    arr2.push(newObj);
                }
            }
            this.noTimeForPersonDetails = arr2
            let arr = [];
            if (CommonFunctions.hasArrayValue(data.timeDetails)) {
                for (let i = 0; i < data.timeDetails.length; i++) {
                    let newObj: TimeDetailBus = new TimeDetailBus(data.timeDetails[i]);
                    if (!this.hasDispatchTime && newObj.timeSource == 1) { this.hasDispatchTime = true; }
                    arr.push(newObj);
                    for (let i = 0; i < 5; i++) {
                        if ((newObj.startDateDateOnly.getDay() == this.noTimeForPersonDetails[i].workDateAdj.getDay())

                        ) {
                            this.dateHasTime[i] = true;
                        }
                    }

            }
            }

            this.timeDetails = arr;
            for (let i = 0; i < 5; i++) {
                var noAprCount = 0;
                var noMgrAprCount = 0;
                if (!this.dateHasTime[i] &&  !this.isFutureDate(this.noTimeForPersonDetails[i].workDateAdj)) {
                    noAprCount++;
                    if (this.noTimeForPersonDetails[i].noTimeApproved == true)
                    {
                        noMgrAprCount++;
                    }
                }
                if (noAprCount > 0) {

                   if (this.mgrAprvd && (noAprCount > noMgrAprCount))
                    { this.mgrAprvd = false; }
                   if( !this.mgrAprvd && this.timeDetails.length == 0 && (noAprCount == noMgrAprCount))
                    { this.mgrAprvd = true; }
                }
            }

            let tempInFinance = this.timeDetails.filter(s => s.inFinance === false);
            this._inFinance = !CommonFunctions.hasArrayElementValue(tempInFinance);
        }
    }
    isFutureDate(date) {
        var today = new Date(Date.now())
        var today = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        return today.getTime() < new Date(date).getTime();
    }
  public  dateHasTime: boolean[] = [];
 name: string;
 fName: string;
 lName: string;
 personId: any;
 mgrName: string;
 billReg: number;
 billOT: number;
 billDT: number;
    billShift: number;
    managerEmail: string;
    resourceEmail: string;
    managerFss: boolean;
    hasDispatchTime: boolean = false;
    hasSalary: boolean = false;
 get billTot(): number
    {
         if (CommonFunctions.hasNumberValue(this.billReg) || CommonFunctions.hasNumberValue(this.billOT) || CommonFunctions.hasNumberValue(this.billDT) || CommonFunctions.hasNumberValue(this.billShift))
             return this.billReg + this.billOT + this.billDT + this.billShift;
         else
             return null;
    }
    set billTot(value: number) { }
 noBillReg: number;
 noBillOT: number;
    noBillDT: number;

    noTimeForPersonDetails: NoTimeForPersonDetailBus[];

get noBillTot(): number
    {
        if (CommonFunctions.hasNumberValue(this.noBillReg) || CommonFunctions.hasNumberValue(this.noBillOT) || CommonFunctions.hasNumberValue(this.noBillDT))
            return this.noBillReg + this.noBillOT + this.noBillDT;
        else
            return null;
    }
    set noBillTot(value: number) { }
 pto: number;
get total(): number
    {
        return this.billTot + this.noBillTot + this.pto;
    }
    set total(value: number) { }
    timeDetails: TimeDetailBus[];
    hasTime: [false,false,false,false,false];
 mgrAprvd: boolean;
    hrsApproved: boolean;
    protected _inFinance: boolean;
    get inFinance(): boolean {
        return this._inFinance;
    }
    get hasTimeDetails(): boolean {
        return CommonFunctions.hasArrayElementValue(this.timeDetails);
    }
    set hasTimeDetails(value: boolean) {
    }
    get canAdd() : boolean {
        let canAdd: boolean = false;
        if (this.hasTimeDetails) {
            let srcOneCount = this.timeDetails.filter(s => s.timeSource === 1);
            if (CommonFunctions.hasArrayElementValue(srcOneCount)) {
                canAdd = true;
            }
        }
        return canAdd;
    }
    set canAdd(value: boolean) {
    }
    get canEdit(): boolean {
        let canEdit: boolean = false;
        if (this.hasTimeDetails) {
            let notApprovedCount = this.timeDetails.filter(s => s.originalMgrApproved === false);
            if (CommonFunctions.hasArrayElementValue(notApprovedCount)) {
                canEdit = true;
            }
        }
        if (CommonFunctions.hasArrayElementValue(this.dateHasTime)) {
            for (let i = 0; i < 5; i++) {
                if (!this.dateHasTime[i] && !this.noTimeForPersonDetails[i].noTimeApproved) {
                    canEdit = true;
                }
            }
        }

        return canEdit;
    }
    set canEdit(value: boolean) {
    }

    get hasBeingApproved(): boolean {
        let hasBeingApproved: boolean = false;
        if (this.hasTimeDetails) {
            let isBeingApprovedCount = this.timeDetails.filter(s => s.originalMgrApproved === false && s.mgrApproved == true);
            if (CommonFunctions.hasArrayElementValue(isBeingApprovedCount)) {
                hasBeingApproved = true;
            }
        }
        return hasBeingApproved;
    }
    set hasBeingApproved(value: boolean) {
    }

    get noTimeUpdated(): boolean {

        if (CommonFunctions.hasArrayValue(this.noTimeForPersonDetails)) {
            return (
                this.noTimeForPersonDetails[0].isUpdated ||
                this.noTimeForPersonDetails[1].isUpdated ||
                this.noTimeForPersonDetails[2].isUpdated ||
                this.noTimeForPersonDetails[3].isUpdated ||
                this.noTimeForPersonDetails[4].isUpdated

            );

        }
        return false;
    }
    clearTotals() {
        this.billDT = 0;
        this.billOT = 0;
        this.billReg = 0;
        this.billShift = 0;
        this.noBillDT = 0;
        this.noBillOT = 0;
        this.noBillReg = 0;
    }
    setChildrenToUpdatedAdded(callSetBeforeSave: boolean = false) {
        this.timeDetails = this.timeDetails.filter(s => s.isUpdated === true || s.isAdded === true);
        if (this.setBeforeSave && CommonFunctions.hasArrayElementValue(this.timeDetails)) {
            for (let i = 0; i < this.timeDetails.length; i++) {
                this.timeDetails[i].setBeforeSave();
            }
        }
    }
    get hasUpdatedChildren(): boolean {
        let hasUC: boolean = false;
        if (CommonFunctions.hasArrayElementValue(this.timeDetails)) {
            var od = this.timeDetails.filter(s => s.isUpdated === true || s.isAdded === true);
            if (CommonFunctions.hasArrayElementValue(od)) {
                hasUC = true;
            }
        }
        return hasUC;
    }
    public static getUpdatedAdded(busObjs: TimeForPersonBus[], callSetBeforeSave: boolean = false): TimeForPersonBus[] {
        let arr: TimeForPersonBus[] = [];
        if (CommonFunctions.hasArrayElementValue(busObjs)) {
            for (let i = 0; i < busObjs.length; i++) {
                if (busObjs[i].hasUpdatedChildren) {
                    let busObj: TimeForPersonBus = new TimeForPersonBus(busObjs[i]);
                    busObj.setChildrenToUpdatedAdded();
                    arr.push(busObj);
                }
            }
        }
        return arr;
    }
    public setTimeDetailTotals(dataObj: TimeForPersonBus) {
        if (dataObj) {
            this.billDT = dataObj.billDT;
            this.billOT = dataObj.billOT;
            this.billReg = dataObj.billReg;
            this.billShift = dataObj.billShift;
            this.noBillDT = dataObj.noBillDT;
            this.noBillOT = dataObj.noBillOT;
            this.noBillReg = dataObj.noBillReg;
        }
    }
    public calculateTimeDetail(setValues: boolean = true) : TimeForPersonBus {

        let dataObj: TimeForPersonBus = new TimeForPersonBus();
        dataObj.clearTotals();
        if (CommonFunctions.hasArrayElementValue(this.timeDetails)) {
            let mgrAprvd = this.timeDetails.filter(s => s.mgrApproved === true);
            this.mgrAprvd = CommonFunctions.hasArrayElementValue(mgrAprvd) && mgrAprvd.length === this.timeDetails.length ? true : false;
            if (CommonFunctions.hasArrayElementValue(this.dateHasTime)) {
                for (let i = 0; i < 5; i++) {
                    if (!this.dateHasTime[i] && !this.noTimeForPersonDetails[i].noTimeApproved) {
                        this.mgrAprvd =false;
                    }
                }
            }

            for (let i = 0; i < this.timeDetails.length; i++) {
                let td: TimeDetailBus = this.timeDetails[i];
                if (td.isBillable) {
                    if (td.payTypeId === CommonValues.LaborType_Reg) {
                        dataObj.billReg += td.hours;
                    }
                    else if (td.payTypeId === CommonValues.LaborType_OT || td.payTypeId === CommonValues.LaborType_ShiftOT) {
                        dataObj.billOT += td.hours;
                    }
                    else if (td.payTypeId === CommonValues.LaborType_DT) {
                        dataObj.billDT += td.hours;
                    }
                    else if (td.payTypeId === CommonValues.LaborType_ShiftPay) {
                        dataObj.billShift += td.hours;
                    }
                }
                else {
                    if (td.payTypeId === CommonValues.LaborType_Reg) {
                        dataObj.noBillReg += td.hours;
                    }
                    else if (td.payTypeId === CommonValues.LaborType_OT) {
                        dataObj.noBillOT += td.hours;
                    }
                    else if (td.payTypeId === CommonValues.LaborType_DT) {
                        dataObj.noBillDT += td.hours;
                    }
                }
            }
        }
        if (setValues) {
            this.setTimeDetailTotals(dataObj);
        }
        return dataObj;
    }
}
